import { render, staticRenderFns } from "./sendProfressor.vue?vue&type=template&id=47ba57ee&scoped=true&"
import script from "./sendProfressor.vue?vue&type=script&lang=js&"
export * from "./sendProfressor.vue?vue&type=script&lang=js&"
import style0 from "./sendProfressor.vue?vue&type=style&index=0&id=47ba57ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba57ee",
  null
  
)

export default component.exports